import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { paths } from "helpers/paths";
import { isDeletedColumn, rowIndexColumn } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import policy from "policies";
import React from "react";
import { Link } from "react-router-dom";

class TransportColumns extends BookIndex {
    state = { tableColumns: this.tableColumns };

    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "name",
                filterable: true,
                Cell: ({
                    value,
                    row: {
                        original: { id },
                    },
                }) =>
                    (policy("user", { user: { roles: this.props.roles } }).isTruckingOrganizationAdmin() ||
                        this.props.roles.isTruckingOrganizationExtendedViewer) ? (
                        <Link to={paths.transportColumnsShow(id)}>{value}</Link>
                    ) : (
                        value
                    ),
            },
            isDeletedColumn(this.restore, this.props.canEditBooks),
        ];
    }

    renderCreateButton = () => {
        const { modal, mergeParams, canCreateBooks } = this.props;
        if (!canCreateBooks) {
            return;
        }
        const action = () =>
            modal({
                name: "createTransportColumn",
                title: "Создание колонны",
                mergeParams,
            });
        return (
            <a className="btn btn-brand btn-sm" onClick={action}>
                Создать колонну
            </a>
        );
    };

    renderListComponent = () => {
        return <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
    };
}

export default tableContainer(TransportColumns, "transportcolumns");
